import { createI18n } from 'vue-i18n'

import en from '~/locales/en.json'
import zh from '~/locales/zh.json'

export const i18n = createI18n({
  legacy: false,
  locale: 'en-US',
  fallbackLocale: 'en-US',
  messages: {
    'en-US': en,
    'zh-CN': zh,
  },
})
